import { FC } from 'react';
import { IconArrowDownBold, IconArrowUpBold } from '@croquiscom-pvt/zds';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';

export interface GroupItem {
  description: string;
  ingredient_name_list: string[];
}

interface Props {
  item: GroupItem & {
    color: string;
    rank: number;
  };
  isActive: boolean;
  onClick: (e: React.MouseEvent) => void;
}

export const IngredientGroupItem: FC<React.PropsWithChildren<Props>> = ({ item, isActive, onClick }) => {
  return (
    <Root onClick={onClick}>
      <Description>
        <Left>
          <Rank bgColor={item.color}>
            <span className={Typography.CAPTION_12_SEMIBOLD}>{item.rank}</span>
          </Rank>
          <span className={Typography.BODY_15_MEDIUM}>{item.description}</span>
        </Left>
        <Right>
          <span className={Typography.BODY_15_MEDIUM}>
            {item.ingredient_name_list.length}
            <span className='unit'>개</span>
          </span>
          {isActive ? (
            <IconArrowUpBold className='icon' size={16} v3Color='gray400' />
          ) : (
            <IconArrowDownBold className='icon' size={16} v3Color='gray400' />
          )}
        </Right>
      </Description>
      {isActive && (
        <Ingredients>
          <IngredientsText className={Typography.BODY_13_MEDIUM}>
            {item.ingredient_name_list.join(', ')}
          </IngredientsText>
        </Ingredients>
      )}
    </Root>
  );
};

const Root = styled.li`
  border-bottom: 1px solid ${vars.v3Color.gray100};
`;

const Description = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 4px;
`;

const Left = styled.div`
  display: flex;
  align-items: center;
`;

const Rank = styled.div<{ bgColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 4px;
  background-color: ${({ bgColor }) => bgColor};
  color: ${vars.v3Color.staticWhite};
  margin-right: 8px;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  color: ${vars.v3Color.gray800};

  .icon {
    margin: 0 4px;
  }

  .unit {
    color: #242729;
    opacity: 0.6;
    margin-left: 2px;
  }
`;

const Ingredients = styled.div`
  padding: 16px;
  background: ${vars.v3Color.gray100};
`;

const IngredientsText = styled.p`
  color: ${vars.v3Color.gray600};
  line-height: 150%;
`;
